import { lazy } from 'react';
import { ROUTES, ORDER_ROUTES, MENU_ROUTES, PRODUCT_ROUTES, PRODUCTION_ROUTES } from '../utils/constants/routes';

interface RouteConfig {
  path: string;
  element: React.LazyExoticComponent<React.FC<object>>;
  auth?: boolean;
  requiredRole?: string;
}

const publicRoutes: RouteConfig[] = [
  { path: ROUTES.LOGIN, element: lazy(() => import('../pages/auth/component/Login')), auth: false },
  { path: ROUTES.FORGOT_PASSWORD, element: lazy(() => import('../pages/auth/component/ForgotPassword')), auth: false },
  { path: ROUTES.RESET_PASSWORD, element: lazy(() => import('../pages/auth/component/ResetPassword')), auth: false },
  { path: ROUTES.COMING_SOON, element: lazy(() => import('../pages/ComingSoon')), auth: false },
];

const privateRoutes: RouteConfig[] = [
  { path: '/', element: lazy(() => import('../pages/home')), auth: true },
  { path: MENU_ROUTES.HOME, element: lazy(() => import('../pages/home')), auth: true },
  { path: ORDER_ROUTES.LIST, element: lazy(() => import('../pages/order-management/index')), auth: true },
  { path: ORDER_ROUTES.CREATE, element: lazy(() => import('../pages/order-management/index')), auth: true },
  { path: ORDER_ROUTES.DETAIL, element: lazy(() => import('../pages/order-management/index')), auth: true },
  { path: MENU_ROUTES.PRODUCTS, element: lazy(() => import('../pages/product-management/index')), auth: true },
  { path: PRODUCT_ROUTES.LIST_PRODUCT_NOT_LINK_ORDER, element: lazy(() => import('../pages/product-management/index')), auth: true },
  { path: PRODUCT_ROUTES.CREATE, element: lazy(() => import('../pages/product-management/index')), auth: true },
  { path: PRODUCT_ROUTES.EDIT, element: lazy(() => import('../pages/product-management/index')), auth: true },
  { path: PRODUCT_ROUTES.IMPORT, element: lazy(() => import('../pages/product-management/index')), auth: true },
  { path: PRODUCT_ROUTES.LIST_IMPORT_PRODUCT, element: lazy(() => import('../pages/product-management/index')), auth: true },

  { path: PRODUCTION_ROUTES.LIST, element: lazy(() => import('../pages/production-management/index')), auth: true },
  { path: PRODUCTION_ROUTES.IMPORT, element: lazy(() => import('../pages/production-management/index')), auth: true },
  { path: PRODUCTION_ROUTES.HISTORY, element: lazy(() => import('../pages/production-management/index')), auth: true },
  { path: `/${MENU_ROUTES.IMPORT_HISTORY}`, element: lazy(() => import('../pages/import-history/index')), auth: true },
];

export { publicRoutes, privateRoutes };
